import { DateAdapter } from '@angular/material/core';
import { NavigatorService } from './../services/navigator.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TimestampFormatPipe } from '../commons/timestampFormatPipe';
import { GenericDetailComponent } from '../shared/GenericDetailComponent';
import { ResponseQueryByCriteria } from '../shared/dto/responseQueryByCriteria';
import { DeviceDTO } from '../shared/dto/device-aziendali/device';
import { DeviceTypeDTO } from '../shared/dto/device-aziendali/deviceType';
import { DeviceTypeService } from '../services/device-aziendali/device-type.service';
import { DeviceAziendaleService } from '../services/device-aziendali/device.service';

@Component({
  selector: 'app-deviceType',
  templateUrl: './deviceTypeDetail.component.html',
  styleUrls: ['./deviceTypeDetail.component.scss']
})

export class DeviceTypeDetailComponent extends GenericDetailComponent implements OnInit, OnDestroy {

  deviceTypeId: number;
  deviceType: DeviceTypeDTO;
  device: DeviceDTO[];

  constructor(
    private deviceTypeService: DeviceTypeService,
    activeRoute: ActivatedRoute,
    dialog: MatDialog,
    snackBar: MatSnackBar,
    timestampFormatPipe: TimestampFormatPipe,
    router: Router,
    navigatorService: NavigatorService,
    dateAdapter: DateAdapter<Date>) {
    super(
      navigatorService,
      dialog,
      router,
      dateAdapter,
      activeRoute,
      snackBar,
      timestampFormatPipe);
    this.form = new FormGroup({
      id: new FormControl({ value: '', disabled: true }),
      descrizione: new FormControl('', Validators.required),
      
      deleteDate: new FormControl({ value: '', disabled: true }),
      deleteUser: new FormControl({ value: '', disabled: true }),
      insertDate: new FormControl({ value: '', disabled: true }),
      insertUser: new FormControl({ value: '', disabled: true }),
      updateDate: new FormControl({ value: '', disabled: true }),
      updateUser: new FormControl({ value: '', disabled: true }),
      optLock: new FormControl({ value: '', disabled: true }),
    });
  }

  ngOnInit() {
    this.deviceTypeId = Number(this.activeRoute.snapshot.paramMap.get("id"));
    if (this.deviceTypeId != null && this.deviceTypeId != 0) {
      this.typeRead();
    } else {
      this.deviceType = new DeviceTypeDTO();
    }
  
  }

  typeSave() {
    if (this.deviceType.id == null) {
      this.typeCreate();
    } else {
      this.typeUpdate();
    }
  }

  typeCreate() {
    if (this.form.valid) {
      this.formToDto();
      this.deviceTypeService.create(this.deviceType).subscribe(
        (res: DeviceTypeDTO) => {
          this.snackBar.open("Salvataggio avvenuto con successo!", null, { duration: 3000 });
          this.deviceType = res;
          this.deviceTypeId = this.deviceType.id;
          this.dtoToForm();
          this.form.markAsPristine();
        }, (err: any) => {
          this.snackBar.open("Errore nel salvataggio!", null, { duration: 3000 });
          console.error("Errore salvataggio:", err);
        }
      );
    }
  }

  typeUpdate() {
    if (this.form.valid && this.form.dirty) {
      this.confirm("Sei sicuro di voler sovrascrivere la tipologia?").subscribe(result => {
        if (result) {
          this.formToDto();
          this.deviceTypeService.update(this.deviceType).subscribe(
            (res) => {
              this.snackBar.open("Salvataggio avvenuto con successo!", null, { duration: 3000 });
              this.typeRead();
              this.form.markAsPristine();
            }, (err: any) => {
              this.snackBar.open("Errore nel salvataggio!", null, { duration: 3000 });
              console.error("Errore salvataggio:", err);
            }
          );
        }
      });
    }
  }

  typeDelete() {
    this.confirm("Sei sicuro di voler cancellare questo tipo?").subscribe(result => {
      if (result) {
        this.formToDto();
        this.deviceTypeService.delete(this.deviceType.id).subscribe(
          (res) => {
            this.snackBar.open("Cancellazione avvenuta con successo!", null, { duration: 3000 });
            this.router.navigate(["/type"]);
          }
        );
      }
    });
  }

  typeRead() {
    this.deviceTypeService.read(this.deviceTypeId).subscribe(
      (res: DeviceTypeDTO) => {
        this.deviceType = res;
        this.deviceTypeId = res.id;
        this.dtoToForm();
      }
    );
  }

  private formToDto(): void {
    this.deviceType.descrizione = this.form.get("descrizione").value;
  }
 
  private dtoToForm(): void {
    this.form.get("id").setValue(this.deviceType.id);
    this.form.get("descrizione").setValue(this.deviceType.descrizione);
    this.form.get("deleteDate").setValue(this.deviceType.deleteDate);
    this.form.get("deleteUser").setValue(this.deviceType.deleteUser);
    this.form.get("insertDate").setValue(this.timestampFormatPipe.transform(this.deviceType.insertDate));
    this.form.get("insertUser").setValue(this.deviceType.insertUser);
    this.form.get("updateDate").setValue(this.timestampFormatPipe.transform(this.deviceType.updateDate));
    this.form.get("updateUser").setValue(this.deviceType.updateUser);
    this.form.get("optLock").setValue(this.deviceType.optLock);
    this.form.markAsPristine();
  }

  ngOnDestroy(): void {
  }
}
